@for (link of links(); track link.id) {
  <a [href]="link.url" target="_blank" rel="nofollow">
    {{ link.label }}
  </a>
}
